import { render, staticRenderFns } from "./ActiveNarrative.vue?vue&type=template&id=bb6b756c&"
import script from "./ActiveNarrative.vue?vue&type=script&lang=ts&"
export * from "./ActiveNarrative.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports